import ToastHighLighter from '@/lib/ToastHighLighter';

export const CarouselCode = () => {
  const language = 'html';
  const codeString = `
  // Carousel
  <div
    id="carouselExampleAutoplaying"
    class="carousel slide carousel-fade"
    data-bs-ride="carousel"
    data-bs-touch="true"
  >
    <div class="carousel-inner">
      <div
        class="carousel-item active"
        data-bs-interval="10000"
        data-bs-pause="true"
      >
        <img
          src="https://webteam.pages.fhnw.ch/fhnw-styleguide-v4/assets/img/campus-muttenz-hoersaal-2.jpg"
          class="d-block w-100"
          alt="..."
        />
        <div class="carousel-caption">
          <a href="#">
            <small>Second slide label</small>
            <h5>
              Some representative placeholder content for the second slide.
            </h5>
          </a>
        </div>
      </div>
      <div class="carousel-item" data-bs-interval="10000">
        <img
          src="https://webteam.pages.fhnw.ch/fhnw-styleguide-v4/assets/img/campus-muttenz-atrium.jpg"
          class="d-block w-100"
          alt="https://dummyimage.com/600x400/000/fff"
        />
        <div class="carousel-caption">
          <a href="#">
            <small>Second slide label</small>
            <h5>Lorem ipsum dolor sit amet...</h5>
          </a>
        </div>
      </div>
      <div class="carousel-item" data-bs-interval="10000">
        <img
          src="https://webteam.pages.fhnw.ch/fhnw-styleguide-v4/assets/img/campus-muttenz-aula.jpg"
          class="d-block w-100"
          alt="..."
        />
        <div class="carousel-caption">
          <a href="#">
            <small>Second slide label</small>
            <h5>
              Some representative placeholder content for the second slide.
            </h5>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-row align-items-center w-100 justify-content-end">
    <button
      class="carousel-control-prev"
      type="button"
      data-bs-target="#carouselExampleAutoplaying"
      data-bs-slide="prev"
    >
      <span
        class="carousel-control-prev-icon"
        aria-hidden="true"
      ></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-bs-target="#carouselExampleAutoplaying"
      data-bs-slide="next"
    >
      <span
        class="carousel-control-next-icon"
        aria-hidden="true"
      ></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'carousel'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
